export default [
  {
    type: 'index',
    formItems: [
      {
        label: "背景图",
        name: "backgroundImage",
        key: "style",
        stamp: 'singleImage',
        help: "背景比例 750*1334 ,图片大小500kb以内",
        defaultValue: '/web_base_assets/scan/store_default_tp.png',
      },
      {
        label: "按钮背景",
        name: "btnBackgroundImage",
        key: "style",
        stamp: 'singleImage',
        help: "背景比例 740*192,文字位置非居中显示,默认背景图底部带边框视觉上制作成居中,位置大概再45%的位置",
        defaultValue: '/web_base_assets/scan/store_open.png',
      },
      {
        label: "背景颜色",
        name: "backgroundColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#ff2419',
      }
    ]
  },
  {
    type: 'win',
    formItems: [
      {
        label: "标题颜色",
        name: "titleColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#F4261F',
      },
      {
        label: "描述文字颜色",
        name: "des_color",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#F4261F',
      },
      {
        label: "文字颜色",
        name: "color",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#F4261F',
      },
      {
        label: "按钮颜色",
        name: "btn_color",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#F4261F',
      },
    ]
  },
  {
    type: 'fw',
    formItems: [
      {
        label: "图标",
        name: "icon",
        key: "style",
        stamp: 'singleImage',
        help: "比例 226*226 ,图片大小500kb以内",
        defaultValue: '/web_base_assets/scan/first_fw.png',
      },
      {
        label: "防伪模板",
        name: "antis_fake_tem_title",
        key: "params",
        stamp: 'query',
        defaultValue: '默认模板',
      },
      {
        label: "主题颜色",
        name: "color",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#4FA1FC',
      },
   
    ]
  },
  {
    type: 'repeat',
    formItems: [
      {
        label: "背景图",
        name: "backgroundImage",
        key: "style",
        stamp: 'singleImage',
        help: "背景比例 660*880 ,图片大小500kb以内",
        defaultValue: '/web_base_assets/scan/store_template_poup.png',
      },
      {
        label: "标题颜色",
        name: "title_color",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#F4261F',
      },
      {
        label: "文字颜色",
        name: "color",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#8E0707',
      },
      {
        label: "背景色",
        name: "backgroundColor",
        key: "style",
        type: "color",
        stamp: 'input'
      },
    ]
  },
  {
    type: 'notWinning',
    formItems: [
      {
        label: "背景图",
        name: "backgroundImage",
        key: "style",
        stamp: 'singleImage',
        help: "背景比例 660*880 ,图片大小500kb以内",
        defaultValue: '/web_base_assets/scan/store_template_poup.png',
      },
      {
        label: "文字颜色",
        name: "title_color",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#F4261F',
      },
      {
        label: "背景色",
        name: "backgroundColor",
        key: "style",
        type: "color",
        stamp: 'input'
      },
    ]
  },
  {
    type: 'repeatFw',
    formItems: [
      {
        label: "图标",
        name: "icon",
        key: "style",
        stamp: 'singleImage',
        help: "比例 226*226 ,图片大小500kb以内",
        defaultValue: '/web_base_assets/scan/second_fw.png',
      },
      {
        label: "防伪模板",
        name: "antis_fake_tem_title",
        key: "params",
        stamp: 'query',
        defaultValue: '默认模板',
      },
      {
        label: "主题颜色",
        name: "color",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#4FA1FC',
      },
    ]
  },
  {
    type: 'collect',
    formItems: [
      {
        label: "标题文字颜色",
        name: "titleColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#333333',
      },
      {
        label: "描述文字颜色",
        name: "desColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#333333',
      },
      {
        label: "弹窗背景图",
        name: "backgroundImage",
        key: "style",
        stamp: 'singleImage',
        help: "背景比例 660*814  ,图片大小500kb以内",
      },
      {
        label: "背景色",
        name: "backgroundColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#fff',
      },
      {
        label: "按钮背景",
        name: "backgroundButtomImage",
        key: "style",
        stamp: 'singleImage',
      },
      {
        label: "按钮颜色",
        name: "buttonColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#FF0E41',
      },
      {
        label: "按钮文字颜色",
        name: "buttonTextColor",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#ffffff',
      },
    ]
  },
  {
    type: 'double',
    formItems: [
      {
        label: "头部背景图",
        name: "backgroundImage",
        key: "style",
        stamp: 'singleImage',
        help: "背景比例 598*220  ,图片大小500kb以内",
        defaultValue: '/web_base_assets/scan/double.gif',
      },
      {
        label: "文字颜色",
        name: "color",
        key: "style",
        type: "color",
        stamp: 'input',
        defaultValue: '#FDE1A2',
      },
      {
        label: "文字提示",
        name: "tips",
        key: "params",
        type: "text",
        stamp: 'input',
        defaultValue: '尊贵的会员 您的奖项已倍增',
      },
    ]
  },
]